import moment from "moment";
import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { withTranslation, useTranslation } from 'react-i18next';
import { FcFinePrint } from "react-icons/fc";
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import Pagination from '../../../components/Pagination/Pagination';
import { DATA_COLLECTION_IMPORT_POLLING_INTERVAL, DC_ITEMS_PER_PAGE, LS_AUTHORITY_KEY, LS_REGULATION_SELECTED_KEY } from '../../../core/constants/common';
import CompanyService from '../../../core/service/CompanyService';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import Utils from '../../../core/utilities/Utils';
import esg_ai from '../../../images/esg_ai.png';
import esg_ai_pic from "../../../images/esg_ai_Green.png";
import CategorySearch from './CategorySearch';
import './GHGEmissions.scss';
import QuestionService from "../../../core/service/QuestionService";


const ViewDataCollection = ({ t, entity }) => {

    const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
    const companyId = lsDat.profile.company.id;
    const glbRegulationId = localStorage.getItem(LS_REGULATION_SELECTED_KEY);
    const { setLoaderDisplay } = useContext(LoaderContext);
    const [itemsTotalCount, setItemTotalCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(DC_ITEMS_PER_PAGE);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataCollection, setDataCollection] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [dbData, setDbData] = useState([]);
    const [selectedDb, setSelectedDb] = useState('NAICS');
    const [parentEntities, setParentEntities] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [childEntities, setChildEntities] = useState([]);
    const [aiStatus, setAiStatus] = useState({});
    const [importInProgress, setImportInProgress] = useState(false);
    let importStatusPoller;
    const [showConfirmationMapping, setShowConfirmationMapping] = useState(false);
    const [selectAllItems, setSelectAllItems] = useState(false);
    const [jobId, setJobId] = useState({});
    const [hasChange, setHasChange] = useState(false);
    const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
    const [pendingPagination, setPendingPagination] = useState(null);
    const [pendingEntityChange, setPendingEntityChange] = useState(null);
    const { k, i18n } = useTranslation();
    useEffect(() => {
        dbInfo();
    }, []);

    useEffect(() => {
        if (!selectedEntity) return;
        // Only proceed if we're not waiting for user confirmation
        if (pendingEntityChange !== null) {
            return;
        }
        clearImportStatusPoller();
        setSelectedItems([]);
        getDataCollection(0, itemsPerPage);
        fetchJobIDForAI();
        return () => {
            // On unmounting
            clearImportStatusPoller();
        };
    }, [selectedEntity]);

    useEffect(() => {
        if (!glbRegulationId) return;
        getEnterprisesByLevel(1);
        getEnterprisesByLevel(2);
    }, [glbRegulationId]);

    // useEffect(() => {
    //     if (jobId && jobId.id > 0) {
    //         fetchImportStatus(true);
    //     }
    // }, [jobId]);

    const fetchImportStatus = (startPoller = false) => {
        GHGEmissionService.categoryWithAIStatus(
            companyId, selectedEntity, jobId.id).then((res) => {
                setAiStatus(res.data);
                if (res.data?.status === 'In Progress') {
                    setImportInProgress(true);
                    if (!startPoller) return;
                    startImportStatusPoller();
                } else {
                    clearImportStatusPoller();
                }
            }).catch(err => {
                clearImportStatusPoller();
            });
    };

    const startImportStatusPoller = () => {
        importStatusPoller = setTimeout(function request() {
            fetchImportStatus();
            importStatusPoller = setTimeout(request, DATA_COLLECTION_IMPORT_POLLING_INTERVAL);
        }, DATA_COLLECTION_IMPORT_POLLING_INTERVAL);
    };

    const clearImportStatusPoller = () => {
        setImportInProgress(false);
        setAiStatus({})
        if (!importStatusPoller) return;
        clearTimeout(importStatusPoller);
    };

    const getEnterprisesByLevel = (level) => {
        CompanyService.getEnterprisesByLevel(level).then(res => {
            if (res.status !== 200) return;
            const entities = res.data.sort((a, b) => a.sortOrder - b.sortOrder);
            if (level === 1) {
                setParentEntities(entities);
            } else if (level === 2) {
                setChildEntities(entities);
            }
        }).catch(err => { });
    };

    const getDataCollection = (pageNumber, itemsPerPageVal) => {
        let perPage = '';
        if (pageNumber > 0) {
            pageNumber = pageNumber - 1;
        } else {
            setCurrentPage(1);
        }
        if (itemsPerPageVal > 0) {
            perPage = itemsPerPageVal;
        } else {
            perPage = itemsPerPage;
        }
        setDataCollection([]);
        setSelectedItems([]);
        setHasChange(false);
        setLoaderDisplay(true);
        GHGEmissionService.getDataCol(
            companyId,
            selectedEntity,
            pageNumber,
            perPage,
            'DRAFT',
            glbRegulationId
        ).then((response) => {
            const totalPages = parseFloat(response.headers["x-total-count"]);
            // Ensure totalPages is a valid number, default to 0 if invalid
            const validTotalPages = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0;
            setItemTotalCount(validTotalPages);
            setDataCollection(response.data);
            // const groupedData = response.data.reduce((acc, item) => {
            //     const dateKey = item.period;
            //     if (!acc[dateKey]) {
            //         acc[dateKey] = [];
            //     }
            //     acc[dateKey].push(item);
            //     return acc;
            // }, {});
            // console.log(groupedData)
            setLoaderDisplay(false);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    };

    const renderEmptyDataLabel = () => {
        return (
            <tr className="Nodatafound_box">
                <td colSpan={10} className='text-center'><FcFinePrint className="me-2" />{t("Nodatafound.label")}</td>
            </tr>
        )
    };

    const renderWhenNotSelected = () => {
        return (
            <div className="Nodatafound_box">
                <h6 className='text-center'><FcFinePrint className="me-2" />{t("SelectEntityText.label")}</h6>
            </div>
        )
    };

    const onPageSelection = (id) => {
        const ids = [...selectedItems];
        const index = selectedItems.indexOf(id);
        if (index >= 0) {
            ids.splice(index, 1);
        } else {
            ids.push(id);
        }
        setSelectedItems(ids);
    };

    const onSelectAllPages = () => {
        if (dataCollection.length === selectedItems.length) {
            setSelectedItems([]);
            return;
        }
        const ids = [];
        dataCollection?.forEach(data => {
            ids.push(data.id);
        });
        setSelectedItems(ids);
    };

    const addCategory = (cat) => {
        let dataCol = JSON.parse(JSON.stringify(dataCollection));
        dataCol.forEach(element => {
            if (selectedItems.includes(element.id)) {
                element['refUSEEIOCode'] = cat['refUSEEIOCode'];
                element['factorWithMargins'] = cat['factorWithMargins'];
                element['categoryName'] = cat['title'];
                element['code'] = cat['code'];
                element['factorId'] = cat['id'];
                element['db'] = selectedDb;
                setHasChange(true);
            }
        });
        setDataCollection(dataCol);
        setShowModal(false);
    }

    const dbInfo = () => {
        setLoaderDisplay(true);
        GHGEmissionService.getDBInfo().then((response) => {
            setLoaderDisplay(false);
            if (response.status !== 200) return;
            setDbData(response.data);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }


    const saveData = () => {
        setLoaderDisplay(true);
        let colData = [];
        dataCollection.forEach(element => {
            if (element['id'] && element['code']) {
                colData.push(element);
            }
        });
        GHGEmissionService.saveCollectionData(
            colData,
            selectedDb,
            companyId,
            selectedEntity,
            false,
            glbRegulationId
        ).then((response) => {
            setLoaderDisplay(false);
            toast.success("Data saved successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setSelectedItems([]);
            setHasChange(false);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const finalizeData = () => {
        if (selectedDb) {
            setLoaderDisplay(true);
            GHGEmissionService.finalizeCollectionData(
                companyId,
                selectedEntity,
                glbRegulationId
            ).then((response) => {
                setLoaderDisplay(false);
                toast.success("Data finalized successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setSelectedItems([]);
                getDataCollection(0, itemsPerPage);
            })
                .catch((error) => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning("Please choose emission table to finalize", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const confirmFinalize = (val) => {
        setShowConfirmation(false);
        if (val) {
            finalizeData();
        }
    };

    const showCategoryModal = () => {
        if (selectedDb && selectedItems.length > 0) {
            setShowModal(true);
        } else {
            toast.warning("Please select items for category mapping", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const aiMapCategory = (job) => {
        if (dataCollection.length > 0) {
            setLoaderDisplay(true);
            GHGEmissionService.mapCategoryWithAI(
                selectedDb,
                companyId,
                selectedEntity,
                job
            ).then((response) => {
                setLoaderDisplay(false);
                toast.success("AI mapping initiated", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                fetchJobIDForAI();
            })
                .catch((error) => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning("No items for AI mapping", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const aiMapCategoryStatus = () => {
        setLoaderDisplay(true);
        GHGEmissionService.categoryWithAIStatus(
            companyId,
            selectedEntity,
            jobId
        ).then((response) => {
            setLoaderDisplay(false);
            setAiStatus(response.data);
        })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const aiSelectedMapCategory = (job) => {
        if (dataCollection.length > 0 && selectedItems.length > 0) {
            setLoaderDisplay(true);
            GHGEmissionService.mapSelectedCategoryWithAI(
                { id_list: selectedItems },
                selectedDb,
                companyId,
                selectedEntity,

                job
            ).then((response) => {
                setLoaderDisplay(false);
                toast.success("AI mapping for selected items is initiated", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setJobId({ id: response.data.job });
            })
                .catch((error) => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning("No items selected for AI mapping", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }
    }

    const getColor = (percentage) => {
        if (percentage < 50) {
            return '#ef4838';  // Red
        } else if (percentage < 75) {
            return '#FFBF00';  // Yellow
        } else {
            return '#5abb6a';  // Green
        }
    };

    const confirmMapping = (val) => {
        setShowConfirmationMapping(false);
        if (val) {
            createJobIDForAI();
        }
    }

    const createJobIDForAI = () => {
        setLoaderDisplay(true);
        GHGEmissionService.createJobIdForAI(companyId, selectedEntity)
            .then((response) => {
                setLoaderDisplay(false);
                if (response.data > 0) {
                    if (selectedItems.length == 0) {
                        aiMapCategory(response.data);
                    } else {
                        aiSelectedMapCategory(response.data)
                    }
                }
            })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const fetchJobIDForAI = () => {
        GHGEmissionService.getJobIdForAI(companyId, selectedEntity)
            .then((response) => {
                setJobId(response.data);
                if (response.data.id > 0) {
                    fetchImportStatus(true);
                }
            })
            .catch((error) => {
            });
    }

    const handleEntityChange = (newEntityId) => {
        // Check if user is trying to change entity when there are unsaved changes
        if (hasChange && selectedEntity !== newEntityId) {
            setPendingEntityChange(newEntityId);
            setShowUnsavedChangesModal(true);
        } else {
            setSelectedEntity(newEntityId);
        }
    }

    const handlePageChange = (pageNum, perPage) => {
        if (hasChange) {
            setPendingPagination({ pageNum, perPage });
            setShowUnsavedChangesModal(true);
        } else {
            getDataCollection(pageNum, perPage);
        }
    }

    const handleUnsavedChangesResponse = async (action) => {
        setShowUnsavedChangesModal(false);
        
        if (action === 'save') {
            // Save data first, then proceed
            setLoaderDisplay(true);
            let colData = [];
            dataCollection.forEach(element => {
                if (element['id'] && element['code']) {
                    colData.push(element);
                }
            });
            try {
                await GHGEmissionService.saveCollectionData(
                    colData,
                    selectedDb,
                    companyId,
                    selectedEntity,
                    false,
                    glbRegulationId
                );
                setLoaderDisplay(false);
                toast.success("Data saved successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setSelectedItems([]);
                setHasChange(false);
                
                // Proceed with pending action
                if (pendingPagination) {
                    getDataCollection(pendingPagination.pageNum, pendingPagination.perPage);
                    setPendingPagination(null);
                } else if (pendingEntityChange !== null) {
                    setSelectedEntity(pendingEntityChange);
                    setPendingEntityChange(null);
                }
            } catch (error) {
                setLoaderDisplay(false);
                toast.error("Failed to save data", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } else if (action === 'discard') {
            // Discard changes and proceed
            setHasChange(false);
            setSelectedItems([]);
            
            // Proceed with pending action
            if (pendingPagination) {
                getDataCollection(pendingPagination.pageNum, pendingPagination.perPage);
                setPendingPagination(null);
            } else if (pendingEntityChange !== null) {
                setSelectedEntity(pendingEntityChange);
                setPendingEntityChange(null);
            }
        } else {
            // Cancel - don't proceed, reset pending actions
            setPendingPagination(null);
            setPendingEntityChange(null);
        }
    }

    return (
        <div className='row m-0 entityFilterbox'>
            <div className="py-2 px-0 col-md-3">
                <div className='d-flex align-items-center'>
                    {/* <label className='me-2 white-space'>{t("Entity.label")} :</label> */}
                    <select className="form-select"
                        onChange={(e) => {
                            handleEntityChange(e.target.value);
                        }}
                        value={selectedEntity || ''}>
                        <option key='' value=''>{t("SelectEntity.label")}</option>
                        {
                            parentEntities?.map((items) => (
                                <option value={items.id} key={items.id}>
                                    {items.name}
                                </option>
                            ))
                        }
                        {
                            childEntities?.map((items) => (
                                <option value={items.id} key={items.id}>
                                    {items.name}
                                </option>
                            ))
                        }
                    </select>
                </div>

            </div>
            <div className='entityFilterbox_inner col-md-9 p-0'>
                <div>
                    {
                        (aiStatus.status === 'In Progress') &&
                        <span className="mx-2 Report_generatBox">
                            <div className="spinner-8"></div>
                            {t('MappingProcessing.label')} {'(' + aiStatus.completed + '/' + aiStatus.total + ')'}
                        </span>
                    }
                </div>
                {/* <div className="py-2 px-0">
                        {
                            importInProgress &&
                            <ProgressBar animated now={aiStatus.percentage} label={`${aiStatus.percentage}%`} />
                        }
                    </div> */}
                <div className="py-2 px-0 pe-2 col-md-3">
                    <div className='d-flex align-items-center'>
                        {/* <label htmlFor="emissionTable" className='me-2 white-space'>{t("EmissionTable.label")} : </label> */}
                        <select id="emissionTable"
                            className="form-select"
                            onChange={(e) => setSelectedDb(e.target.value)}
                            value={selectedDb}>
                            <option key='' value='' disabled>{t("SelectEmissionTable.label")}</option>
                            {
                                dbData.length > 0 && (
                                    dbData?.map(d => {
                                        return <option key={d} value={d}>{d}</option>;
                                    })
                                )
                            }
                        </select>
                    </div>
                </div>
                <div className="py-2 px-0">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-like">{t("MapHelpText.label")}</Tooltip>} >
                        <Button
                            variant='primary'
                            type="button"
                            className="mx-2"
                            disabled={dataCollection.length == 0 || aiStatus.status === 'In Progress'}
                            onClick={() => {
                                showCategoryModal()
                            }}>
                            {t("MapCategory.label")}
                        </Button>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-like">{t("MapWithAIHelpText.label")}</Tooltip>} >
                        <Button
                            variant='ESGAi'
                            type="button"
                           
                            disabled={!selectedEntity || dataCollection.length == 0 || aiStatus.status === 'In Progress'}
                            onClick={() => {
                                setShowConfirmationMapping(true);
                            }}>
                            <img src={esg_ai} width={15} height={15} alt="ESG AI" /> {t("MapWithAI.label")}
                        </Button>
                    </OverlayTrigger>

                    {/* <Dropdown>
                            <Dropdown.Toggle variant="secondary" id="dropdown-basic" className={`sbmBtn mx-2`}>
                                <span>{t("MapCategory.label")}</span> <FaChevronDown />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={Utils.renderTooltip(
                                        t("MapHelpText.label")
                                    )}>
                                    <Dropdown.Item onClick={() => showCategoryModal()} disabled={dataCollection.length == 0 || selectedItems.length == 0}>
                                        {t("ManualMapping.label")}
                                    </Dropdown.Item>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={Utils.renderTooltip(
                                        t("MapWithAIHelpText.label")
                                    )}>
                                    <Dropdown.Item onClick={() => aiMapCategory()} disabled={dataCollection.length == 0 || importInProgress}>
                                        {t("MapWithAI.label")}
                                    </Dropdown.Item>
                                </OverlayTrigger>

                            </Dropdown.Menu>
                        </Dropdown> */}

                </div>
            </div>

            {
                selectedEntity &&
                <div className='col-md-12 p-0'>
                    <div className='EntityFinalizeTable'>
                        <Table responsive bordered className='mb-0'>
                            <thead>
                                <tr>
                                    <th>
                                        {/* <Dropdown>
                                            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input cursor"
                                                    id={`selectAllpageCheckbox`}
                                                    checked={selectedItems?.length === dataCollection.length}
                                                    disabled
                                                />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href="#" onClick={() => onSelectAllPages()}>Select This Page</Dropdown.Item>
                                                <Dropdown.Item href="#" onClick={() => { setSelectAllItems(true); onSelectAllPages() }}>Select All</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown> */}
                                        <input
                                            type="checkbox"
                                            className="form-check-input cursor"
                                            id={`selectAllpageCheckbox`}
                                            checked={selectedItems?.length === dataCollection.length}
                                            onChange={() => onSelectAllPages()}
                                        />
                                    </th>
                                    <th>Period</th>
                                    <th>Item</th>
                                    <th>Supplier</th>
                                    <th>Quantity</th>
                                    <th>UOM </th>
                                    <th>Cost In USD</th>
                                    <th>Category</th>
                                    <th>Ref USEEIO Code</th>
                                    <th>Emission Factor</th>
                                    {/* <th>Confidence</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {dataCollection.length > 0 ? (
                                    dataCollection.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input cursor"
                                                    id={`pageCheckbox-${index}`}
                                                    checked={selectedItems.indexOf(item.id) >= 0}
                                                    onChange={() => onPageSelection(item.id)}
                                                />
                                            </td>
                                            <td className='white-space'>{moment(item.period).format("MMM DD, YYYY")}</td>
                                            <td>{item.item}</td>
                                            <td>{item.supplier}</td>
                                            <td>{Utils.formattedNumber(item.quantity)}</td>
                                            <td className='uom_tb'>{item.uom}</td>
                                            <td>{Utils.formattedNumber(item.costInUSD)}</td>
                                            <td className='Category_td'>
                                                <div className='category_name_td'>
                                                    {item?.categoryName}
                                                    {item?.aiFlag &&

                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={Utils.renderTooltip(
                                                                `AI mapped with ${item?.confidence ?? 0}% confidence`
                                                            )}>
                                                            <span className="AI_Icon_DC">
                                                                <img src={esg_ai_pic} />
                                                            </span>
                                                        </OverlayTrigger>
                                                    }
                                                </div>
                                            </td>
                                            <td>{item.refUSEEIOCode}</td>
                                            <td>{item.factorWithMargins}</td>
                                            {/* <td>
                                                {item?.aiFlag &&
                                                    <div style={{ width: 40, height: 40 }}>
                                                        <CircularProgressbar value={item?.confidence ?? 0}
                                                            styles={buildStyles({
                                                                pathColor: getColor(item?.confidence),
                                                                textColor: getColor(item?.confidence),
                                                                trailColor: '#dee8ed'
                                                            })}
                                                            text={`${item?.confidence ?? 0}%`} strokeWidth={10} />
                                                    </div>
                                                }
                                            </td> */}
                                        </tr>
                                    ))
                                ) :
                                    renderEmptyDataLabel()
                                }
                            </tbody>
                        </Table>
                        <div className="py-2 List_footer_count">
                            <Pagination
                                itemsTotalCount={itemsTotalCount}
                                itemsPerPage={itemsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                alwaysShown={true}
                                setItemsPerPage={setItemsPerPage}
                                pageClicked={(pageNum, perPage) => {
                                    handlePageChange(pageNum, perPage);
                                }}
                                pageInfo={'DataCollection'}
                            />
                        </div>
                    </div>
                    {dataCollection.length > 0 &&
                        <div className='text-center px-2'>
                            {/* <Button variant='secondary' className='px-3 me-2'>Back</Button> */}
                            <Button variant='primary' className='px-3 me-2' onClick={() => saveData()}>{t("SaveDraft.label")}</Button>
                            <Button variant='primary' className='px-3' onClick={() => setShowConfirmation(true)} disabled={hasChange}>{t("Finalize.label")}</Button>
                        </div>
                    }
                </div>
            }

            {
                !selectedEntity &&
                renderWhenNotSelected()
            }

            {
                showModal &&
                <CategorySearch db={selectedDb} onShowModal={showModal} onHideModal={(val) => setShowModal(val)} onAddCategory={(cat) => addCategory(cat)} />
            }

            {showConfirmation && (
                <ConfirmationModal
                    modalShow={true}
                    messageText={t("FinalizeReportModal.label")}
                    callbackModal={confirmFinalize}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            )}

            {showConfirmationMapping && (
                <ConfirmationModal
                    modalShow={true}
                    messageText={t("AIMappingModal.label")}
                    callbackModal={confirmMapping}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            )}

            {showUnsavedChangesModal && (
                <Modal
                    show={showUnsavedChangesModal}
                    onHide={() => handleUnsavedChangesResponse('cancel')}
                    aria-labelledby="unsaved-changes-modal-title"
                    size="sm"
                    centered
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header className="border-0" closeButton>
                        <Modal.Title as="h5">{t("UnsavedChanges2.label")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex align-items-center justify-content-center shortDataHeight">
                            {t("UnsavedChangesMessage.label")}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            className="px-3"
                            onClick={() => handleUnsavedChangesResponse('cancel')}
                        >
                            {t("Cancel.label")}
                        </Button>
                        <Button
                            variant="outline-danger"
                            className="px-3"
                            onClick={() => handleUnsavedChangesResponse('discard')}
                        >
                            {t("DiscardAndContinue.label")}
                        </Button>
                        <Button
                            variant="primary"
                            className="px-3"
                            onClick={() => handleUnsavedChangesResponse('save')}
                        >
                            {t("SaveAndContinue.label")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default withTranslation()(ViewDataCollection);